/** Registration flow steps (Talent School). */
export enum Step {
  CHILD_INFO = 0,
  PARENT_INFO = 1,
  SAFETY_INFO = 2,
  CLASS_SELECTION = 3,
  REVIEW_PAY = 4,
  SUCCESS = 5,
}

export interface EmergencyContact {
  name: string;
  relation: string;
  phone: string;
}

export interface ForumClassItem {
  id: string;
  nameEn: string;
  nameEs: string;
  scheduleEn: string;
  scheduleEs: string;
  time: string;
  price: number;
  ageRange?: [number, number];
  externalLink?: string;
  externalEmail?: string;
}

export interface ForumFormData {
  childName: string;
  school: string;
  age: string;
  housePhone: string;
  motherName: string;
  motherCell: string;
  fatherName: string;
  fatherCell: string;
  parentEmail: string;
  emergencyContacts: EmergencyContact[];
  medicalConditions: string;
  selectedClasses: string[];
  // Fiscal and payment (Phase 1)
  fiscalName: string;
  documentType: "RNC" | "CEDULA";
  documentNumber: string;
  /** DGII: B02 Consumidor Final, B01 Crédito Fiscal, B15 Gubernamental, B14 Régimen Especial */
  comprobanteType: "B01" | "B02" | "B14" | "B15";
  schoolType: "AMERICAN_SCHOOL" | "EXTERNO";
  studentCode: string;
  paymentFrequency: "BIMESTRAL" | "CUATRIMESTRAL";
  cardCode: string;
  classFrequencies: Record<string, "BIMESTRAL" | "CUATRIMESTRAL">;
}
